/**
 * WebMCP 游戏状态资源
 * 提供完整的游戏状态信息
 */
/* eslint-disable */
var t = require('../lang').t;
var store = require('../../store').default;
var blockShape = require('../../unit/const').blockShape;

/**
 * 获取游戏状态
 */
function getGameState(format) {
  format = format || 'json';
  var state = store.getState();

  // 确定游戏状态
  var gameStateStr = 'waiting';
  if (state.get('reset')) {
    gameStateStr = 'over';
  } else if (state.get('pause')) {
    gameStateStr = 'paused';
  } else if (state.get('cur') !== null) {
    gameStateStr = 'playing';
  }

  // 获取当前方块信息
  var cur = state.get('cur');
  var currentPiece = null;
  if (cur !== null) {
    var xy = cur.xy;
    // xy 是 Immutable List [row, col]，即 [y, x]
    var xyArray = xy && typeof xy.get === 'function' ? [xy.get(1), xy.get(0)] : (xy.x !== undefined ? [xy.x, xy.y] : [0, 0]);
    currentPiece = {
      type: cur.type,
      x: xyArray[0],  // x = col
      y: xyArray[1],  // y = row
      rotation: cur.rotateIndex,
      shape: cur.shape.toJS ? cur.shape.toJS() : cur.shape,
    };
  }

  // 获取矩阵
  var matrix = state.get('matrix');
  var matrixData = matrix && matrix.toJS ? matrix.toJS() : [];

  // 构建状态对象
  var status = {
    gameState: gameStateStr,
    score: state.get('points') || 0,
    highScore: state.get('max') || 0,
    level: state.get('speedRun') || 1,
    linesCleared: state.get('clearLines') || 0,
    currentPiece: currentPiece,
    nextPiece: state.get('next') || null,
    matrix: matrixData,
    speed: state.get('speedRun') || 1,
    isLocked: state.get('lock') || false,
    startLines: state.get('startLines') || 0,
    music: state.get('music') || false,
    isPaused: state.get('pause') || false,
    isGameOver: state.get('reset') || false,
  };

  if (format === 'text') {
    return formatGameStateText(status);
  }

  return status;
}

/**
 * 将游戏状态格式化为可读文本
 */
function formatGameStateText(status) {
  var lines = [];

  lines.push(t('=== 俄罗斯方块游戏状态 ===', '=== Tetris Game State ==='));
  lines.push(t('游戏状态: ', 'Game state: ') + getGameStateLabel(status.gameState));
  lines.push(t('分数: ', 'Score: ') + status.score);
  lines.push(t('最高分: ', 'High score: ') + status.highScore);
  lines.push(t('等级: ', 'Level: ') + status.level);
  lines.push(t('消除行数: ', 'Lines cleared: ') + status.linesCleared);

  if (status.currentPiece) {
    lines.push(t('当前方块: ', 'Current piece: ') + status.currentPiece.type + t(' 位置(', ' at (') + status.currentPiece.x + ', ' + status.currentPiece.y + ')');
  } else {
    lines.push(t('当前方块: 无', 'Current piece: none'));
  }

  lines.push(t('下一个方块: ', 'Next piece: ') + (status.nextPiece || t('未知', 'unknown')));
  lines.push(t('起始行数: ', 'Start lines: ') + status.startLines);
  lines.push(t('音效: ', 'Sound: ') + (status.music ? t('开启', 'on') : t('关闭', 'off')));
  lines.push(t('锁定状态: ', 'Locked: ') + (status.isLocked ? t('是', 'yes') : t('否', 'no')));

  // 简化的矩阵显示
  lines.push('');
  lines.push(t('游戏区域（非空行）:', 'Board (non-empty rows):'));
  var matrix = status.matrix;
  var hasContent = false;
  for (var i = 0; i < matrix.length; i++) {
    var row = matrix[i];
    var hasBlock = false;
    for (var j = 0; j < row.length; j++) {
      if (row[j] !== 0) {
        hasBlock = true;
        break;
      }
    }
    if (hasBlock || (status.currentPiece && i >= status.currentPiece.x - 2)) {
      var rowStr = '';
      for (var k = 0; k < row.length; k++) {
        rowStr += row[k] ? '■' : '□';
      }
      var rowNum = i.toString();
      while (rowNum.length < 2) {
        rowNum = '0' + rowNum;
      }
      lines.push('  ' + rowNum + ': ' + rowStr);
      hasContent = true;
    }
  }
  if (!hasContent) {
    lines.push('  （空）');
  }

  return lines.join('\n');
}

/**
 * 获取游戏状态的中文标签
 */
function getGameStateLabel(state) {
  var labels = {
    waiting: t('等待开始', 'waiting'),
    playing: t('游戏中', 'playing'),
    paused: t('已暂停', 'paused'),
    over: t('游戏结束', 'over'),
  };
  return labels[state] || state;
}

/**
 * WebMCP 状态查询工具
 */
var stateTool = {
  name: 'tetris_get_state',
  description: t('获取当前游戏状态。可选择返回 JSON 格式或可读文本格式', 'Get the current game state. Choose JSON or readable text format'),
  inputSchema: {
    type: 'object',
    properties: {
      format: {
        type: 'string',
        enum: ['json', 'text'],
        description: t('返回格式：json（结构化数据）或 text（可读文本）', 'Return format: json (structured) or text (readable)'),
        default: 'json',
      },
    },
  },
  execute: function(args) {
    args = args || {};
    var format = args.format || 'json';
    var state = getGameState(format);

    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: typeof state === 'string' ? state : JSON.stringify(state, null, 2),
        },
      ],
    });
  },
};

/**
 * WebMCP 资源定义
 */
var gameStateResource = {
  uri: 'tetris://state',
  name: '俄罗斯方块游戏状态',
  description: '当前游戏的完整状态信息',
  mimeType: 'application/json',
  read: function() {
    var state = getGameState('json');
    return Promise.resolve({
      contents: [
        {
          uri: 'tetris://state',
          mimeType: 'application/json',
          text: JSON.stringify(state, null, 2),
        },
      ],
    });
  },
};

module.exports = {
  stateTool: stateTool,
  gameStateResource: gameStateResource,
  getGameState: getGameState,
};



// WEBPACK FOOTER //
// ./src/webmcp/resources/gameState.js